// Copyright (c) 2025. CYBERKOALA LLC.
//
// SPDX-License-Identifier: Proprietary License.
//
// Redistribution and use in source and binary forms, with or without
// modification, are restricted.
import { Outlet, useNavigate } from 'react-router-dom';
import { MeSettingsSidebar } from '@/pages/channels/@me/_components/me-settings-sidebar.tsx';
import { cn } from '@/lib/utils';
import { isPardusBrowser } from '@/components/check-user-agent';
import { MobileSettingsToggle } from '@/pages/channels/@me/_components/mobile-settings-toggle.tsx';
import { XCircleIcon } from 'lucide-react';

/**
 * TODO: make modal on top of current server page to show server at BG
 * @constructor
 */
const SettingsModal = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 z-0 flex h-full bg-background/90 backdrop-blur-md">
      <div className="absolute top-2 left-2 md:hidden">
        <MobileSettingsToggle />
      </div>
      <div className="hidden w-[72px] md:flex" />
      <div className="hidden md:flex w-72 border-r border-border bg-white dark:bg-black h-full">
        <MeSettingsSidebar />
      </div>
      <div className="flex-1 overflow-auto p-6">
        <div className={cn(isPardusBrowser() && 'pt-[2em]')} />
        <div className="pr-1 md:pr-6">
          <Outlet />
        </div>
        <button
          onClick={() => navigate('/')}
          className={cn(
            isPardusBrowser() && 'pt-[2em]',
            'absolute top-2 right-1 md:right-4 text-muted-foreground hover:text-foreground flex flex-col gap-1'
          )}
        >
          <XCircleIcon />
          <span className="text-sm">ESC</span>
        </button>
      </div>
      <div className={cn(isPardusBrowser() && 'pt-[2em]')} />
    </div>
  );
};

export default SettingsModal;
